/**
 * Convert an image File to a base64 data URL.
 * @param {File} file
 * @returns {Promise<string>} data URL
 */
export async function imageToDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
  
  /**
   * Convert a data URL back into a File object.
   * @param {string} dataUrl
   * @param {string} filename
   * @returns {File}
   */
  export function dataURLtoFile(dataUrl, filename) {
    const [meta, base64] = dataUrl.split(",");
    const mime = meta.match(/:(.*?);/)[1];
    const binary = atob(base64);
    let len = binary.length;
    const u8arr = new Uint8Array(len);
    while (len--) {
      u8arr[len] = binary.charCodeAt(len);
    }
    return new File([u8arr], filename, { type: mime });
  }
  
  /**
   * Resize a base64 data URL so it fits within maxW × maxH,
   * preserving aspect ratio and outputting JPEG at given quality.
   *
   * @param {string} dataUrl  — original base64 URL
   * @param {number} maxW     — max width
   * @param {number} maxH     — max height
   * @param {number} quality  — 0–1 JPEG quality
   * @returns {Promise<string>} resized data URL
   */
  export async function resizeImageDataURL(dataUrl, maxW, maxH, quality = 0.8) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const ratio = Math.min(maxW / img.width, maxH / img.height, 1);
        const w = img.width * ratio;
        const h = img.height * ratio;
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = reject;
      img.src = dataUrl;
    });
  }
  
  const imageConversions = {
    imageToDataURL,
    dataURLtoFile,
    resizeImageDataURL,
  };
  
  export default imageConversions;
  